/**
 * Created with IntelliJ IDEA.
 * User: elinar
 * Date: 12/1/14
 * Time: 4:46 PM
 * To change this template use File | Settings | File Templates.
 */


define(function (require) {
    "use strict";

    var ErrorCodes = require("codeTables/errorCodes.json");

    var BaseFeatureController = require("personalization-controllers/BaseFeatureController");
    var WidgetEditLayout = require("personalization-web-agent-views/widget-views/widget-edit/WidgetEditLayout");
    var WidgetEditView = require("personalization-web-agent-views/widget-views/widget-edit/WidgetEditView");
    var WidgetParametersEditView = require("personalization-web-agent-views/widget-views/widget-edit/WidgetParametersEditView");
    var WidgetCollection = require("personalization-web-agent-collections/WidgetCollection");
    var WidgetParametersCollection = require("personalization-web-agent-collections/WidgetParametersCollection");
    var WidgetModel = require("personalization-web-agent-models/WidgetModel");

    var LEKPEvent = "openKP";
    var KP_ID = "iframe-integration";

    var IFrameIntegrationEditController = {};
    LE.module('LEPersonalization', function (LEPersonalization, LE, Backbone, Marionette, $, _) {
        IFrameIntegrationEditController = BaseFeatureController.extend({

            /************************** Marionette overriden functions *****************************************/
            initialize: function (options) {
                LEPersonalization.logger.info("initializing", "IFrameIntegrationEditController:initialize");
                this.vent = options.vent;
                this.editedModel = options.editedModel;
                this.collection = options.collection;

                this.addCustomFields = LE.crossModule("webagent", LE.media.actions.request, LE.mediaCodes.webAgent.reqres.addCustomVariables);

                this._createViews();
                this._bindEvents();
            },

            onClose: function () {
                LEPersonalization.logger.info("closing", "IFrameIntegrationEditController:onClose");
            },

            /************************** Public functions *****************************************************/
            getEditView:function(options){
                LEPersonalization.logger.info("getEditView", "IFrameIntegrationEditController:getEditView");
                return this.widgetEditLayout;
            },

            getAnchorModel:function(){
                return new (Backbone.Model.extend({}))();
            },

            /************************** private functions *****************************************************/
            _createViews: function () {
                LEPersonalization.logger.info("creating views", "IFrameIntegrationEditController:_createViews");
                this.widgetEditLayout = new WidgetEditLayout();

                this._createWidgetParameters();
                this.widgetEditView = new WidgetEditView({
                    vent: this.vent,
                    model: this.editedModel,
                    paramsMap: this.paramsMap,
                    addCustomFields: this.addCustomFields
                });
            },

            _bindEvents:function(){
                LEPersonalization.logger.info("binding events", "IFrameIntegrationEditController:_bindEvents");

                this.listenTo(this.widgetEditLayout, "render", this._onWidgetEditLayoutRender);

                this.listenTo(this.vent, "widget-edit:cancel", this._onWidgetEditCancel);
                this.listenTo(this.vent, "widget-edit:save", this._onWidgetEditSave);
                this.listenTo(this.vent, "widget-edit:change:pilot", this._onWidgetPilotStateChange);
                this.listenTo(this.vent, "widget-edit:change:name", this._onWidgetNameChange);
                this.listenTo(this.vent, "widget-edit:change:description", this._onWidgetDescriptionChange);
                this.listenTo(this.vent, "widget-edit:change:size", this._onWidgetSizeChange);
                this.listenTo(this.vent, "widget-edit:change:skills", this._onWidgetSkillsChange);
                this.listenTo(this.vent, "widget-edit:change:URL", this._onWidgetURLChange);
                this.listenTo(this.vent, "widget-edit:change:FallbackURL", this._onWidgetFallbackURLChange);
                this.listenTo(this.vent, "widget-edit:change:FallbackURLTimeoutChange", this._onWidgetFallbackURLTimeoutChange);
                this.listenTo(this.vent, "widget-edit:URL-link:click", this._onWidgetURLLinkClick);
                this.listenTo(this.vent, "widget-edit:params-button:click", this._onWidgetParamsButtonClick);

                this.listenTo(this.vent, "widget-edit-params:cancel", this._onWidgetEditParamsCancel);
                this.listenTo(this.vent, "widget-edit-params:save", this._onWidgetEditParamsSave);
            },

            _onWidgetEditLayoutRender: function(){
                this.widgetEditLayout.widgetEditRegion.show(this.widgetEditView);
            },

            _showWidgetEditView: function(){
                this.widgetEditLayout.widgetEditParamsRegion.reset();
                this.widgetEditLayout.ui.widgetEditRegion.show();
            },

            _createWidgetParameters: function(){
                var systemParamsArray = LE.crossModule("webagent", LE.media.actions.request, LE.mediaCodes.webAgent.reqres.getFlatWidgetConfig);

                this.systemParamsItems = [];
                this.paramsMap = {};

                _.each(systemParamsArray, function(systemParamsCategory){
                    var categoryName = systemParamsCategory.name;
                    _.each(systemParamsCategory.rows, function(systemParamsObj){
                        this.systemParamsItems.push({
                            id: systemParamsObj.key,
                            value: LE.translator.translate(systemParamsObj.name),
                            group: LE.translator.translate(categoryName),
                            subText: (systemParamsObj.isIdentifier) ? "✭" : "",
                            tooltip: (systemParamsObj.isIdentifier) ? LE.translator.translate("LEPersonalization.webAgent.widget.widgetEdit.paramsEdit.systemParam.identifier.tooltip") : ""
                        });
                        this.paramsMap[systemParamsObj.key] = LE.translator.translate(systemParamsObj.name);
                    }, this);
                }, this);
            },

            _onWidgetEditCancel: function(){
                this._onWidgetEditClose();
            },

            _onWidgetEditSave: function(){
                LEPersonalization.loader.setLoader();

                this.editedModel.save(null, {
                    ignoreError: true,
                    success: _.bind(function (model, response, options) {
                        LEPersonalization.loader.closeLoader();
                        LEPersonalization.logger.info("model save success", "IFrameIntegrationEditController:_onWidgetEditSave");
                        this.collection.add(model, {merge: true});

                        this._onWidgetEditClose();
                    }, this),
                    error: _.bind(function (model, response, options) {
                        LEPersonalization.loader.closeLoader();
                        LEPersonalization.logger.error("model save error", "IFrameIntegrationEditController:_onWidgetEditSave", response);

                        if (response && response.responseError && response.responseError.internalCode) {
                            if (response.responseError.internalCode === ErrorCodes.uniquenessViolation) {
                                LEPersonalization.notifier.showError({
                                    content: LE.translator.translate("LEPersonalization.webAgent.widget.widgetEdit.errors.name.not.unique"),
                                    timeToShow: 6000
                                });
                            }
                            else if (response.responseError.internalCode === ErrorCodes.maxEntityLimitViolation) {
                                LEPersonalization.notifier.showError({
                                    content: LE.translator.translate("LEPersonalization.webAgent.widget.widgetEdit.errors.max.widgets"),
                                    timeToShow: 6000
                                });
                            }
                            else{
                                this._showGeneralSaveError();
                            }
                        }
                        else{
                            this._showGeneralSaveError();
                        }
                }, this)
                });
            },

            _showGeneralSaveError: function(){
                LEPersonalization.notifier.showError({
                    content: LE.translator.translate("LEPersonalization.webAgent.widget.widgetEdit.errors.default.save"),
                    timeToShow: 6000
                });
            },

            _onWidgetPilotStateChange: function(options){
                this.editedModel.togglePilotMode(options.value);
            },

            _onWidgetNameChange: function(options){
                this.editedModel.setName(options.value);
            },

            _onWidgetDescriptionChange: function(options){
                this.editedModel.setDescription(options.value);
            },

            _onWidgetSizeChange: function(options){
                this.editedModel.setSize(options.value);
            },

            _onWidgetSkillsChange: function(options){
                this.editedModel.setSkills(options.value);
            },

            _onWidgetURLChange:  function(options){
                this.editedModel.setURL(options.value);
            },

            _onWidgetFallbackURLChange:  function(options){
                this.editedModel.setFallbackURL(options.value);
            },

            _onWidgetFallbackURLTimeoutChange:  function(options){
                this.editedModel.setFallbackURLTimeout(options.value);
            },

            _onWidgetURLLinkClick: function(){
                LE.vent.trigger(LEKPEvent, {fragment: KP_ID});
            },

            _onWidgetParamsButtonClick: function(){
                var widgetParametersEditView = new WidgetParametersEditView({
                    vent: this.vent,
                    collection: new WidgetParametersCollection(this.editedModel.getParameters()),
                    systemParamsItems: this.systemParamsItems,
                    addCustomFields: this.addCustomFields,
                    paramsMap: this.paramsMap
                });

                this.widgetEditLayout.widgetEditParamsRegion.show(widgetParametersEditView);
                this.widgetEditLayout.ui.widgetEditRegion.hide();
            },

            _onWidgetEditParamsCancel: function(){
                this._closeWidgetEditParams();
            },

            _onWidgetEditParamsSave: function(options){
                if(_.isEmpty(options.parametersCollection.validate()) && !this._validationErrorsOnItemViews(options.parametersCollection)){
                    this.editedModel.setParameters(options.parametersCollection.toJSON());
                    this._closeWidgetEditParams();
                }
                else{
                    LEPersonalization.notifier.showError({
                        content: LE.translator.translate("LEPersonalization.webAgent.widget.widgetEdit.paramsEdit.errors.save"),
                        timeToShow: 6000
                    });
                }
            },

            _validationErrorsOnItemViews: function(collection){
                var isValid = true;
                _.each(collection.models, function(model){
                    isValid = isValid && _.isNull(model.validationError);
                });

                return !isValid;
            },

            _closeWidgetEditParams: function(){
                this._showWidgetEditView();
            },

            /************************** Utility private functions that does not need "this" ********************/
            _onWidgetEditClose: function(){
                LEPersonalization.navigateToPageMenu();
            }
        });
    });
    return IFrameIntegrationEditController;
});
